import PropTypes from 'prop-types'
import React, { useState, useImperativeHandle, useRef, useEffect } from 'react'
import { Colors } from 'Theme'
import styles from './IFSelectPicker.module.css'
import { IFText, IFsvg } from 'Components'
import { SelectPicker } from 'rsuite'
import { getTextWidth } from '../../../Utils/Calculations'

const IFSelectPicker = React.forwardRef(
  ({ title, data, onValueChange = () => {}, initialValue, width }, ref) => {
    const [isOpen, setIsOpen] = useState(false)
    const [value, setValue] = useState(initialValue)
    const clearValue = () => {
      setValue('')
    }

    const options = []
    for (const index in data) {
      options.push({
        label: data[index],
        value: data[index],
      })
    }

    useImperativeHandle(ref, () => ({
      clearValue,
      isOpen,
    }))
    const pickerRef = useRef()
    const menuRef = useRef()
    useEffect(() => {
      const errorHandler = (e) => {
        if (
          e.message.includes(
            'ResizeObserver loop completed with undelivered notifications' ||
              'ResizeObserver loop limit exceeded',
          )
        ) {
          const resizeObserverErr = document.getElementById(
            'webpack-dev-server-client-overlay',
          )
          if (resizeObserverErr) {
            resizeObserverErr.style.display = 'none'
          }
        }
      }
      window.addEventListener('error', errorHandler)
      return () => {
        window.removeEventListener('error', errorHandler)
      }
    }, [])
    useEffect(() => {
      const handleScroll = (e) => {
        const menuEl = document.querySelector('.rs-picker-menu')
        if (menuEl && menuEl.contains(e.target)) return

        if (isOpen && menuRef?.current?.close) {
          menuRef.current.close()
          const wrapper = menuRef.current?.root
          const toggle = wrapper?.querySelector('.rs-picker-toggle')
          if (toggle) {
            toggle.blur()
            toggle.classList.remove('rs-picker-toggle-active')
          }

          setIsOpen(false)
        }
      }
      window.addEventListener('scroll', handleScroll, true)
      return () => {
        window.removeEventListener('scroll', handleScroll, true)
      }
    }, [isOpen])

    return (
      <div ref={pickerRef} className={styles.wrapperContainer}>
        <div className={styles.container}>
          <SelectPicker
            ref={menuRef}
            style={{
              ...(width
                ? { width: width }
                : {
                    width: getTextWidth(title, `600 ${14}px ProximaNova`) + 16,
                  }),
            }}
            className={styles.SelectPicker}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            value={value}
            onSelect={(value) => {
              setValue(value)
              onValueChange(value)
            }}
            container={() => document.body}
            preventOverflow={false}
            placement="autoVerticalStart"
            data={options}
            cleanable={false}
            size="lg"
            searchable={false}
            placeholder={title}
            renderValue={() => (
              <div>
                <IFText>{title}</IFText>
              </div>
            )}
          />
          <div className={styles.TextWrapper}>
            <IFText className={styles.Text}>
              {/* {Replacing all spaces with &nbsp; for styling} */}
              {title.replaceAll(' ', '\u00a0')}
            </IFText>
            <div className={styles.Icon}>
              <IFsvg.Expand
                height={20}
                width={20}
                fill={Colors.FilterIconFilled}
              />
            </div>
          </div>
        </div>
      </div>
    )
  },
)

IFSelectPicker.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  onValueChange: PropTypes.func.isRequired,
  initialValue: PropTypes.string,
  width: PropTypes.number,
}

export default IFSelectPicker
